import { AddEditLocationRequest } from "./add-edit-location.request";

export interface BulkUpdateLocationRequest {
    locations?: AddEditLocationRequest[];
    isCalculateETA?: boolean;
    connectionId ? : string;
}